<template>
  <div class="page-collect" :class="{'mobile': _isMobile}">
    <div class="collect-wrap " :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="4"></cmpBanner>

      <div class="g-wrap">
        <div class="g-content">
          <div class="collect-swiper">
            <cmpSwiper ref="cmpSwiper" @refresh="getDetailData"></cmpSwiper>
          </div>

          <div class="info-box">
            <div class="g-detail-title">
              <h1>藏品详情</h1>
            </div>

            <cmpDetail :detailData="detailData" :hideName="true"></cmpDetail>
            <!-- <div class="g-detail-html trans">
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Dolorum qui, quidem numquam modi eveniet debitis id nulla expedita architecto accusamus ipsam iusto doloribus sit autem, repellendus dolor recusandae. Perspiciatis, libero?</p>
            </div> -->
          </div>

          <!-- 其他藏品 勿删 -->
          <!-- <div class="other-list">
            <h2 class="g-title-2">其他藏品</h2>

            <el-row class="list g-card-list" :gutter="_isMobile?0:40">
              <el-col class="item g-card-1" :span="_isMobile?24:12" v-for="(item, index) in dataList" :key="index">
                <div @click="goDetail(item)">
                  <div class="pic-box pic1">
                    <img v-lazy="item.pictureUrl" alt="">
                  </div>
                  <div class="info m-circle">
                    <h2 class="title m-font-2">{{item.activityName}}</h2>
                    <p class="time m-font-4">中国历史学年代{{item.activityTime}}</p>
                  </div>
                </div>
              </el-col>

              <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
                <div class="no-data-bg"></div>
                <p class="txt text-center">暂无数据</p>
              </div>
            </el-row>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/collect/detail.scss'
import cmpSwiper from '@cmp/swiper'
export default {
  components: { cmpSwiper },
  data() {
    return {
      pageType: this.$route.query.pageType,
      detailData: {
        content: ''
      },
      detailId: this.$route.query.id,
      dataList: [],
      listQuery: {
        currentPage: 1,
        size: 2,
      },
      total: 0,
      listLoading: false,
    }
  },
  methods: {
    getDataList(val) {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('../singleMuseum/api/bsActivity/getActivityListForPublic', {
          ...this.listQuery,
          state: val || this.activeSubVal
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
            // this.dataList = []
            // this.dataList.map((item, index) => {
            //   this.$nextTick(() => {
            //     this.createQrcode(item)
            //   });
            // })
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    getDetailData() {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('/webapi/collection/detail', {
          id: this.detailId
          // id: '21010302862103A000047'
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.data

            this.$nextTick(() => {
              // this.initSwiper()
              console.log(this.detailData)
              this.$refs.cmpSwiper.init(this.detailData)
            })
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    goDetail(item) {
      console.log(item)
      this.$router.push({
        path: '/activity/detail',
        query: {id: item.id, pageType: this.activeVal}
      })
    },
    setBread() {
      // 动态修改面包屑 2 资讯  6 制度建设
      console.log('00', this.pageType)
      switch(this.pageType) {
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '社教活动',
              href: '/activity?pageType=1'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '2':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '游学活动',
              href: '/activity?pageType=2'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '3':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '讲座',
              href: '/activity?pageType=3'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '4':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '手工',
              href: '/activity?pageType=4'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '5':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            }, 
            {
              text: '其他',
              href: '/activity?pageType=5'
            }, 
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }
    }
  },
  created() {
    // this.setBread()
    this.getDetailData()
    // this.getDataList()
  }
}
</script>

<style lang="scss" scoped>
.collect-wrap {
  .info-box {
    margin: 30px 0;
    padding: 40px;
    background: #fff;
  }
  .other-list {
    h2 {
      color: #3D3D3D;
      margin-bottom: 24px;
    }
    .list {
      .item {
        .info {
          padding-bottom: 30px;
          height: 122px;
          h2 {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .g-detail-html {
    width: 100%;
  }
}
</style>


